import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ModificationCommonService } from '../../services/modification-common.service';
import { MaterialModule } from '../../material.module';
import { IncomeProofNextStepComponent } from '../income-proof-next-step/income-proof-next-step.component';


@Component({
  selector: 'app-income-proof-bottomsheet',
  imports: [MaterialModule],
  templateUrl: './income-proof-bottomsheet.component.html',
  styleUrl: './income-proof-bottomsheet.component.less'
})
export class IncomeProofBottomsheetComponent {
  uploadForm!: FormGroup;
  btnLoader = false;
    isBankStatement: any;

  constructor(
      private fb: FormBuilder,
      private _bottomSheet: MatBottomSheet,
      private _bottomSheetRef: MatBottomSheetRef<IncomeProofBottomsheetComponent>,
      private modificationCommonService: ModificationCommonService, 
      @Inject(MAT_BOTTOM_SHEET_DATA) public data: boolean
  ) {
    this.isBankStatement = data == false?data:true;
  }

  ngOnInit(): void {
      this.uploadForm = this.fb.group({
          selectedOption: ['17', Validators.required]
      });
  }

  openLink(event: MouseEvent): void {
      this._bottomSheetRef.dismiss();
      event.preventDefault();
  }

  selectProofOption() {
      try {
          let value = this.uploadForm.get('selectedOption')?.value;
          this.openBottomSheet(value);
      } catch (e) {
          console.error(e);
      }
  }

  openBottomSheet(value:string | number): void {
      this._bottomSheet.open(IncomeProofNextStepComponent, { data: { value: value } });
  }
}
